import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalHeader } from "../ModalHeader";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useEffect, useState } from "react";
import { Autocomplete, Divider, Grid, MenuItem, Select, TextField, Typography } from "@mui/material";
import { ModalFooter } from "../ModalFooter";
import '../../../assets/styles/modals.scss';
import { PhasesService } from "@/service/services/Phases.service";
import { Loading } from "@/components/common/Loading";
import { AssistanceService } from "@/service/services/Assistance.service";
import { Props } from "./ModalDelay.type";

export const ModalDelay: React.FC<Props> = (props:any): JSX.Element => {

    const { open, closeModal, actionSelected, delay, onListDelays, workerSelected, clearState } = props;

    const [loading, setLoading] = useState<boolean>(false);
    const [typeAbsences, setTypeAbsences] = useState<any>([]);
    const [typeDiscounts, setTypeDiscounts] = useState<any>([]);

    const [data, setData] = useState({
        id: delay ? delay.id : '',
        idemployee: delay ? delay.idemployee : '',
        date: delay ? delay.date : '',
        total_delay: delay ? delay.total_delay : '',
        observation: delay ? delay.observation : '',
    });

    const validateForm = (values) => {
        let errors: any = {};
        if(!values.total_delay) errors.total_delay = "total tardanzas requerido";
        if(!values.observation) errors.observation = "observación requerido";
        if(!values.date) errors.date = "fecha requerido";
        return errors;
    }

    const onSubmit = async(values, {resetForm})  => {

        const formData = {
            id: values.id,
            idemployee: workerSelected.id,
            date : values.date,
            total_delay : values.total_delay,
            observation : values.observation,
        }
        setLoading(true);
        if(delay && actionSelected=='edit'){
            await AssistanceService.editDelay(formData, delay.id).then((data) => {
                onListDelays && onListDelays(workerSelected.id);
                closeModal && closeModal();
            })
        }else{
            await AssistanceService.createDelay(formData).then((data) => {
                onListDelays && onListDelays(workerSelected.id);
                closeModal && closeModal();
            })
        }
        setLoading(false);
    }
    return(
        <>
        {loading && <Loading/>}

        <Modal open={open} handleClose={closeModal} handle size="sm">
            <ModalHeader
                text={(delay && actionSelected=='edit') ? "Editar tardanza" : "Agregar tardanza"}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) =>{
                        return(
                            <form onSubmit={handleSubmit}>
                                <Grid container >

                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>Fecha:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                id="date"
                                                variant="standard"
                                                fullWidth
                                                name="date"
                                                type="date"
                                                onChange={handleChange}
                                                value={values.date}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                error={errors.date && touched.date ? true : false}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>total tardanzas:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="total_delay"
                                            variant="standard"
                                            type="number" 
                                            name="total_delay"
                                            fullWidth
                                            value={values.total_delay}
                                            onChange={handleChange}
                                            placeholder="total tardanzas"
                                            error={errors.total_delay && touched.total_delay ? true : false}
                                        />
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>Observación:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="observation"
                                            variant="standard"
                                            type="text" 
                                            name="observation"
                                            multiline
                                            maxRows={4}
                                            fullWidth
                                            value={values.observation}
                                            onChange={handleChange}
                                            placeholder="observacion"
                                            error={errors.observation && touched.observation ? true : false}
                                        />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={(delay && actionSelected=='edit') ? "ACTUALIZAR" : "REGISTRAR"}
                                    cancelText="CANCELAR" 
                                    onCancel={closeModal}
                                    onConfirm={handleSubmit}
                                    clearState={clearState}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
        </>
    );
}